import React from 'react';

export function TruncatedText({
  text,
  size,
  defaultHeight = '60px'
}) {
  if (typeof text !== 'string') {
    return <div />;
  }

  if (!size) {
    return (
      <div title={text} style={{ overflow: 'hidden', maxHeight: defaultHeight, textAlign: 'left' }}>
        {text}
      </div>
    );
  }

  return (
    <div title={text} style={{ overflow: 'hidden', maxHeight: defaultHeight, textAlign: 'left' }}>
      {text.length > size && text.length > 0 ? `${text.substring(0, size)}...` : text}
    </div>
  );
}